<template>
  <div v-if="this.data != '' && this.data != null" class="text">
    <div class="box" v-html="this.highlightedText"></div>
    <PDFViewer ref="pdfViewer" />
  </div>
</template>

<script>

  import {mapState} from "vuex";
  import Utils from '../utils'
  import PDFViewer from './PDFViewer.vue'

  export default {
  name: 'HackettIndexResult',
  components: {
    PDFViewer
  },
  props: {
    data: Object,
    title: String,
    columnName: String,
    largerFont: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('app', [
      'searchText',
      'searchType',
      'allowEdits'
    ]),
    highlightedText() {
      //console.log("hackett index data=",this.data)
      var uni1 = this.data.tense1_unicode != "" ? this.data.tense1_unicode + '།' : '';
      var uni2 = this.data.tense2_unicode != "" ? this.data.tense2_unicode + '།' : '';
      var uni3 = this.data.tense3_unicode != "" ? this.data.tense3_unicode + '।' : '';
      var uni4 = this.data.tense4_unicode != "" ? this.data.tense4_unicode + '।' : '';
      let highlighted = Utils.highlight(`${uni1} ${uni2} ${uni3} ${uni4}`, this.searchText, 'highlight');
      return `Class ${this.data['class']}, <a href="#" class="page-link" onclick="event.preventDefault(); this.dispatchEvent(new CustomEvent('open-pdf', { bubbles: true, detail: ${this.data.page} }))">p. ${this.data.page}</a>, <span style="font-size: 160%">${highlighted}</span>`
    },
  },
  mounted() {
    this.$el.addEventListener('open-pdf', this.openPDF);
  },
  beforeUnmount() {
    this.$el.removeEventListener('open-pdf', this.openPDF);
  },
  methods: {
    handleClick() {
      if (this.allowEdits) {
        alert("This cannot yet be edited. Sorry.")
      }
    },
    openPDF(event) {
      const pageNumber = event.detail;
      this.$refs.pdfViewer.open(pageNumber);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .result-title {
    font-weight: bold;
    margin-right:5px;
  }

  .largerfont {
    font-size: 160% !important;
    line-height: 80%;
  }

  .box {
    border-radius: 10px;
    background-color: #f9f9f9;
    padding: 10px;
  }

  .box :deep(.page-link) {
    color: #007bff;
    text-decoration: none;
    cursor: pointer;
  }

  .box :deep(.page-link:hover) {
    text-decoration: underline;
  }

</style>
